// drawer/components/TIProviderRiskBadge.tsx
import { cn } from '@/utils/classname';

interface TIProviderRiskBadgeProps {
  score: number;
  severity: 'critical' | 'high' | 'medium' | 'low';
}

const SEVERITY_STYLES: Record<string, string> = {
  critical:
    'border-chariot-stroke-critical bg-chariot-status-critical text-chariot-text-primary',
  high: 'border-chariot-stroke-high bg-chariot-status-high text-chariot-text-primary',
  medium:
    'border-chariot-stroke-medium bg-chariot-status-medium text-chariot-text-primary',
  low: 'border-chariot-stroke-low bg-chariot-status-low text-chariot-text-primary',
};

/**
 * Colored risk score badge for TI provider scores
 */
export function TIProviderRiskBadge({
  score,
  severity,
}: TIProviderRiskBadgeProps) {
  return (
    <span
      data-testid="ti-risk-badge"
      className={cn(
        'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold',
        SEVERITY_STYLES[severity] ?? SEVERITY_STYLES.low
      )}
    >
      {score}
    </span>
  );
}
